import React from 'react';
import { path } from 'ramda';
import { ButtonProps } from 'antd/lib/button/button';
import ButtonIv from '../button';
import { useTheme } from '../../../common/styling/theme';

interface CustomButtonProps {
  children?: React.ReactNode;
}

const ButtonPrimary = ({ children, ...buttonAntDesignProps }: CustomButtonProps & ButtonProps) => {
  const { theme } = useTheme();
  return (
    <ButtonIv
      width="280px"
      backgroundColor={path(['colors', 'secondary', 'main'], theme)}
      borderRadius="30px"
      {...buttonAntDesignProps}
    >
      {children}
    </ButtonIv>
  );
};

export default ButtonPrimary;
